import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core";
import { InputLabel, Input, LinearProgress } from "@mui/material";
import Table from "@mui/material/Table";
import TableChartIcon from "@mui/icons-material/TableChart";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { UploadFileAction, listUploadedFiles } from "actions/productActions";
import { getFiles } from "services/UploadFilesService";
import LoadingBox from "components/LoadingBox";
import MessageBox from "components/MessageBox";
import Notification from "components/Notification";
import styles from "assets/jss/vivoleo-react-kit/views/landingPageSections/UploadVideoScreenStyles.js";
import { CheckFileType } from "services/UploadFilesService";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ShowMedia from "components/ShowMedia";

const useStyles = makeStyles(styles);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function UploadVideoScreen(props) {
  const { id } = useParams();
  const classes = useStyles();
  const productId = id;
  const userSignin = useSelector((state) => state.userSignin);
  const uploadedfiles = useSelector((state) => state.uploadedFilesList);
  const { loading: loading, records: records, error: error } = uploadedfiles;
  const { userInfo } = userSignin;
  const redirect = "/uploadvideo";
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState("");
  const [progress, setProgress] = useState(0);
  const [otherinfo, setOtherinfo] = useState("");
  const [fileInfos, setFileInfos] = useState([]);

  const uploadFile = useSelector((state) => state.uploadFile);
  const {
    loading: loadingUpload,
    error: errorUpload,
    data: uploadedVideo,
  } = uploadFile;

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectFile = (event) => {
    const inputfile = event.target.files;
    console.log("inputfile: " + event.target.files);
    setSelectedFiles(event.target.files);
    /*
    if (CheckFileType(event.target.files[0])) {
      setSelectedFiles(event.target.files);
    } else {
      setNotify({
        isOpen: true,
        message: "please select audio, video or image file!",
        type: "error",
      });
      setAlertMessage("please select audio, video or image file!");
    }
    */
  };

  const upload = (e) => {
    e.preventDefault();
    const user = userInfo._id;
    let currentFile = selectedFiles[0];
    setProgress(0);
    setCurrentFile(currentFile);
    dispatch(
      UploadFileAction(
        currentFile,
        title,
        otherinfo,
        user,
        userInfo,
        (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        }
      )
    );
  };
  /*
  useEffect(() => {
    if (uploadedVideo) {
      setNotify({
        isOpen: true,
        message: "File Uploaded Successfully",
        type: "success",
      });
      //navigate(redirect, { replace: true });
      setImage(uploadedVideo.savedFile);
      setSelectedFiles(undefined);
    } else {
      console.log("error:" + errorUpload);
      setNotify({
        isOpen: true,
        message: errorUpload,
        type: "error",
      });
    }
  }, []);
*/
  useEffect(() => {
    /*
  getFiles().then((response) => {
    setFileInfos(response.data);
  });
  */
    dispatch(listUploadedFiles());
    if (process === 100) {
      setNotify({
        isOpen: true,
        message: "File Uploaded Successfully",
        type: "success",
      });
      //      setImage(uploadedVideo);
      setSelectedFiles(undefined);
      navigate(redirect, { replace: true });
      window.location.reload();
    }
    /*
    else {
      console.log("error:" + errorUpload);
      setNotify({
        isOpen: true,
        message: errorUpload,
        type: "error",
      });
    }
    */
  }, []);
  //console.log("uploadedVideo: " + uploadedVideo);
  return (
    <div>
      <div className={classes.space30}> </div>
      <GridItem xs={12} sm={4} md={4}>
        <Button
          variant="outlined"
          className="medium"
          startIcon={
            <KeyboardBackspaceOutlinedIcon className={classes.vivoblueColor} />
          }
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </GridItem>
      <div className={classes.textCenter}>
        <h1>Upload Video {productId}</h1>
      </div>
      <div className={classes.space30}> </div>
      <MessageBox variant="danger">{alertmessage}</MessageBox>
      {currentFile && (
        <div className="progress">
          <div
            className="progress-bar progress-bar-info progress-bar-striped"
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: progress + "%" }}
          >
            {progress}%
          </div>
          <LinearProgress variant="determinate" value={progress} />
        </div>
      )}
      <form onSubmit={upload} className="form">
        <div className={classes.space30}> </div>

        <input
          id="btn-upload"
          name="btn-upload"
          type="file"
          //accept="audio/*,video/*,image/*"
          onChange={selectFile}
        />

        <div className={classes.space30}> </div>
        <div>
          <InputLabel htmlFor="title">Title</InputLabel>
          <Input
            fullWidth={true}
            id="title"
            placeholder="Enter Title"
            defaultValue={title}
            onChange={(e) => setTitle(e.target.value)}
          ></Input>
        </div>
        <div className={classes.space30}> </div>
        <div>
          <InputLabel htmlFor="otherinfo">Other Information</InputLabel>
          <Input
            id="otherinfo"
            placeholder="please add more information if needs"
            required
            sx={{ width: "100%" }}
            onChange={(e) => setOtherinfo(e.target.value)}
          ></Input>
        </div>
        <div className={classes.space30}> </div>
        <Button type="submit" className="medium" disabled={!selectedFiles}>
          Upload
        </Button>
      </form>
      {/* 
            <div>
        <label htmlFor="image">Image</label>
        <input
          id="image"
          type="text"
          placeholder="Enter image"
          value={image}
          onChange={(e) => setImage(e.target.value)}
        ></input>
      </div>
      */}

      {loadingUpload && <LoadingBox></LoadingBox>}
      {errorUpload && <MessageBox variant="danger">{errorUpload}</MessageBox>}

      <div className={classes.space30}> </div>
      {/* 
      <div className="card">
        <div className="card-header">List of Files</div>
        <ul className="list-group list-group-flush">
          {fileInfos &&
            fileInfos.map((file, index) => (
              <li className="list-group-item" key={index}>
                <a href={file.newfilepath}>{file.title}</a>
              </li>
            ))}
        </ul>
      </div>
      */}
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <center>
            <h3>All Uploaded Files</h3>
          </center>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.space30}> </div>
        </GridItem>

        <GridItem xs={12} sm={4} md={4}>
          <Button
            variant="outlined"
            className="medium"
            startIcon={<TableChartIcon className={classes.vivoblueColor} />}
            onClick={() => window.location.reload()}
          >
            To Show All Uploaded Files
          </Button>
        </GridItem>

        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.space30}> </div>
            </GridItem>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 400 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">Title</StyledTableCell>
                    <StyledTableCell align="left">Uploaded By</StyledTableCell>
                    <StyledTableCell align="left">
                      Other Information
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Uploaded Date
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {records.map((x) => (
                    <>
                      <StyledTableRow>
                        <StyledTableCell align="left">
                          <Button className="small" href={x.newfilepath}>
                            {x.title}
                          </Button>
                        </StyledTableCell>
                        <StyledTableCell align="left">{x.user}</StyledTableCell>
                        <StyledTableCell align="left">
                          {x.otherinfo}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {x.createdAt}
                        </StyledTableCell>
                      </StyledTableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        <Notification notify={notify} setNotify={setNotify}></Notification>
      </GridContainer>
    </div>
  );
}
